<template>
    <span
        v-if="legend.is_bic || legend.is_fic"
        class="fic-bic-tag"
        @mouseover="showTooltip"
        @mouseleave="hideTooltip"
    >
        {{ legend.is_fic_bic ? "FIC/BIC" : legend.is_fic ? "FIC" : "BIC" }}
    </span>
</template>

<script>
import * as d3 from "d3";

export default {
    props: {
        legend: {
            type: Object,
        }, 
        chart: {
            type: Object,
        },        
        hasMany: {
            type: Boolean,
        },
    },
    methods:{
        showTooltip(event) {
            if(!this.hasMany) return;
            const refElement = event.target
                .getBoundingClientRect();
            const tooltip = d3.select(`#view-chart-${this.chart.chartId}`).select(".legend-tooltip");

            let textToDisplay = 
                (this.hasMany ? this.legend.brand_name + ' - ' : '') + 
               ( this.legend.is_fic_bic ? 'First in Class / Best in Class' : ( this.legend.is_fic ?  'First in Class': 'Best in Class'));

            tooltip.select("span").html(textToDisplay);
            if (refElement && refElement.x && refElement.y) {
                let left = refElement.left - 57 + 8;
                if(this.legend.is_fic_bic){
                    left = refElement.left - 30 + 8;
                }
                tooltip.attr("style", `top: ${refElement.y - 55}px; left: ${left}px;`);
            }
            tooltip.classed("open", true);
        },
        hideTooltip() {
            if(!this.hasMany) return;
            const tooltip = d3.select(`#view-chart-${this.chart.chartId}`).select(".legend-tooltip");
            tooltip.classed("open", false);
        },
    }
};
</script>

<style lang="scss">
    @import '../../../../style/Charts/ViewChart/Legend/FicBicTag.scss';
</style>
